module.exports = __webpack_public_path__ + "static/payment-1890e533369e6f9edde3417cd7a15a3f.svg";